import { SystemService } from '@core/services/system/system.service';
import { ProgressBar } from 'primeng/progressbar';
import { LoadingService } from 'src/app/core/services/loading/loading.service';

import { NgIf } from '@angular/common';
import { Component, OnInit, effect, inject } from '@angular/core';

@Component({
  selector: 'app-loading-page',
  template: `
    <section *ngIf="display" id="container-loading-page">
      <img id="logo-confear" [src]="logo" alt="logo confear" />
      <p-progressBar
        [style]="{ height: '30px', width: '400px' }"
        mode="indeterminate"></p-progressBar>
    </section>
  `,
  styleUrls: ['./loading-page.component.scss'],
  imports: [ProgressBar, NgIf]
})
export class LoadingPageComponent implements OnInit {
  display: boolean;
  logo: string;
  systemService = inject(SystemService);
  loadingService = inject(LoadingService);

  constructor() {
    effect(() => {
      const config = this.systemService.configuracao();
      this.logo = `assets/logos${config?.imgLogoLoading}`;
    });
  }

  ngOnInit(): void {
    this.loadingService.listen().subscribe((display: boolean) => {
      this.display = display;
    });
  }
}
